import React, { useEffect, useRef } from 'react';
import '../styles/cursor.css';

const Cursor = () => {
  const cursorRef = useRef(null);
  const followerRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const follower = followerRef.current;
    let posX = 0, posY = 0;
    let mouseX = 0, mouseY = 0;

    const animate = () => {
      posX += (mouseX - posX);
      posY += (mouseY - posY);

      cursor.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
      follower.style.transform = `translate3d(${posX}px, ${posY}px, 0)`;

      requestAnimationFrame(animate);
    };

    const handleMouseMove = (e) => {
      mouseX = e.clientX - cursor.offsetWidth / 2;
      mouseY = e.clientY - cursor.offsetHeight / 2;
    };

    document.addEventListener('mousemove', handleMouseMove);

    animate();

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className="cursor"></div>
      <div ref={followerRef} className="cursor-follower"></div>
    </>
  );
};

export default Cursor;